<div class="snackbar-container" [ngClass]="data.type">
  <mat-icon class="snackbar-icon">{{ getIcon() }}</mat-icon>
  <span class="snackbar-message">{{ data.message }}</span>
  <button mat-icon-button class="snackbar-close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>